import RingLoader from '@jetbrains/ring-ui/components/loader/loader'

import isVisualTest from '../../../utils/isVisualTest'

function Loader({stop, ...restProps}: {stop?: boolean; className?: string}) {
  const stopProp = isVisualTest() || stop
  return (
    <RingLoader
      {...restProps}
      stop={stopProp}
      {...(isVisualTest()
        ? {
            deterministic: true,
          }
        : {})}
    />
  )
}

export default Loader
